import React from 'react';
import AdditionalReportFunctional from './components/additional-report-list-functional';
import './additional-report.scss';

const AdditionalReport = () => {
	return <AdditionalReportFunctional />;
};

export default AdditionalReport;
